import { useEffect, useRef } from "react";
import Legend from "@arcgis/core/widgets/Legend";
import Query from "@arcgis/core/rest/support/Query.js";
import * as query from "@arcgis/core/rest/query.js";


const LegendComponent = ({ mapView }) => {

    let mapLegend = useRef(null);

    useEffect(() => {


        if (mapLegend.current.innerHTML !== "") {
            mapLegend.current.removeChild(mapLegend.current.children[0])
        }

        let legend = new Legend({
            view: mapView,
            container: mapLegend.current,
        });


    }, [mapView])

    return (
        <>
            <div ref={mapLegend} />
        </>
    )
}
export default LegendComponent;